module.exports = __webpack_public_path__ + "static/ring_of_regeneration-d366d575b3964729cd0dba7ba4089391.jpeg";